import React from "react";
import { Helmet } from "react-helmet";
import { educareLogo } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";

const FreeSeminar = () => {
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Free Seminar - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Free Seminar" />
      <div className="max-w-screen-2xl h-auto mx-auto pt-4 pb-20">
        <div className="w-full shadow-md shadow-primeColor hover:shadow-darkPink transition-hover duration-300 mx-auto h-full flex flex-col justify-top py-14 px-10 lg:px-32 items-start gap-4">
          <div className="w-full flex flex-col gap-4 md:flex-row justify-between items-center">
            <h1 className="font-titleFont text-4xl font-semibold lg:mb-4 underline underline-offset-8 decoration-[2px] decoration-gray-400">
              Free Online Seminar
            </h1>
            <img className="w-52" src={educareLogo} alt="educareLogo" />
          </div>
          <div className="grid grid-cols-1 gap-3">
            <p className="font-bodyFont text-lg text-gray-600 tracking-wide">
              Free Seminar details will update Soon!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeSeminar;
